import { useTranslation } from 'react-i18next';
import { isEmpty } from 'utils/Utils';

const CustomModal = ({
  title = '',
  isTitleRed = false,
  message,
  isShowTwoButton = false,
  isActiveCancel = false,
  customTwoButton = false,
  onSubmit,
  onClose,
  onCancel,
}) => {
  const { t } = useTranslation();

  const titleContent = () => {
    if (isEmpty(title)) {
      return;
    }

    if (isTitleRed) {
      return <div className="title-error">{title}</div>;
    } else {
      return <div className="title">{title}</div>;
    }
  };

  const buttonContent = () => {
    if (isShowTwoButton && customTwoButton) {
      return (
        <div className="button button-2">
          <ul>
            <li onClick={() => onCancel()} style={{ color: '#163B6A' }}>
              {'해외발행카드'}
            </li>
            <li onClick={() => onSubmit()} style={{ color: '#163B6A' }}>
              {'국내카드'}
            </li>
          </ul>
        </div>
      );
    } else if (isShowTwoButton && !isActiveCancel) {
      return (
        <div className="button button-2">
          <ul>
            <li onClick={() => onClose()}>{t('cancel')}</li>
            <li onClick={() => onSubmit()}>{t('ok')}</li>
          </ul>
        </div>
      );
    } else if (isShowTwoButton && isActiveCancel) {
      return (
        <div className="button button-2">
          <ul>
            <li onClick={() => onCancel()}>{t('cancel')}</li>
            <li onClick={() => onSubmit()}>{t('ok')}</li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className="button button-1">
          <ul>
            <li onClick={() => onClose()}>{t('ok')}</li>
          </ul>
        </div>
      );
    }
  };

  return (
    <>
      <div className="alert"></div>
      <div className="alert-wrap">
        <div className="middle">
          <div className="popup">
            {customTwoButton && (
              <button className="close-btn" onClick={() => onClose()}>
                ×
              </button>
            )}
            {titleContent()}
            <div className="text">{message}</div>
            {buttonContent()}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomModal;
